import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/pro-light-svg-icons";
import { cn } from "@core/lib/utils";

export interface LogoutOptionProps {
  signOutBtnClassName?: string;
  signOutIcon?: any; // You can refine this type to IconProp if needed
  signOutLabel?: string;
  onLogout: () => void;
}

export const LogoutOption: React.FC<LogoutOptionProps> = ({
  signOutBtnClassName,
  signOutIcon,
  signOutLabel,
  onLogout,
}) => {
  return (
    <button
      className={cn("p-2 gap-2 w-full flex items-center", signOutBtnClassName)}
      onClick={onLogout}
    >
      <FontAwesomeIcon icon={signOutIcon || faSignOut} fixedWidth />
      <span>{signOutLabel || "Log Out"}</span>
    </button>
  );
};
